import { isGrpLoginLoadingSelector } from '../../../redux/selectors/e3DGrpAuthSelectors'
import { connect, MapStateToProps } from 'react-redux'
import E3DLoadingSpinner from './E3DLoadingSpinner'
import is3DExhibitionEnabledSelector from '../../../redux/selectors/feature-scope/is3DExhibitionEnabledSelector'

type StateProps = {
    isLoading: boolean
    is3DExhibitionEnabled: boolean
}

const mapStateToProps: MapStateToProps<StateProps, {}> = (state): StateProps => {
    return {
        isLoading: isGrpLoginLoadingSelector(state),
        is3DExhibitionEnabled: is3DExhibitionEnabledSelector(state),
    }
}

export default connect(mapStateToProps)(E3DLoadingSpinner)
